export default __webpack_public_path__ + "static/ogX-c59317541672c121be83e03ad2e43cb7.jpg";